import React from 'react';
import {View} from 'react-native';
import {useFocusEffect} from '@react-navigation/native';
import {observer} from 'mobx-react';

import Text from '../../components/ui-controls/Text';
import {AppRoute} from '../../models/AppRoute';
import {Department} from '../../models/middleware';
import {RouteNavigatorScreenProps} from '../../models/navigationTypes';
import {GIFT_CARDS_TILE} from '../../stores/rangeStore';
import {useStores} from '../../stores/use-stores';

import RangeProductListScreen from './RangeProductListScreen';
import RangeSubDepartmentsScreen from './RangeSubDepartmentsScreen';

const TmpScreen = ({text}: {text: string}) => (
  <View>
    <Text>{text}</Text>
  </View>
);

const DepartmentScreen = observer(
  ({route, navigation}: RouteNavigatorScreenProps<AppRoute.DEPARTMENT>) => {
    const {rangeStore, promotionsStore} = useStores();

    const {department} = route.params;

    if (!department) {
      return <TmpScreen text="Category not found" />;
    }

    // When navigating directly to /shop/categories/gift-cards
    useFocusEffect(
      React.useCallback(() => {
        console.log('');
        if (department.id === GIFT_CARDS_TILE) {
          promotionsStore.navigateToGiftCardsPromotionOrLoadingScreen(
            navigation.navigate,
            false,
          );
        }
      }, [department.id, navigation.navigate, promotionsStore]),
    );

    if (department.id === GIFT_CARDS_TILE) {
      return <TmpScreen text="Loading your Gift Cards..." />;
    }

    rangeStore.selectDepartment(department);

    const handleSubDepartmentPress = (subDepartment: Department) => {
      rangeStore.selectSubDepartment(subDepartment);
      navigation.navigate(AppRoute.SUB_DEPARTMENT, {
        department: department,
        subDepartment: subDepartment,
      });
    };

    const subDepartments = rangeStore.getSubDepartments(department.id);
    if (subDepartments.length > 0) {
      subDepartments.unshift({
        ...department,
        name: 'View All',
      });
      return (
        <RangeSubDepartmentsScreen
          department={department}
          subDepartments={subDepartments}
          onSubDepartmentPress={handleSubDepartmentPress}
        />
      );
    } else {
      // TODO: This depends on  rangeStore.selected... 🙄
      return <RangeProductListScreen />;
    }
  },
);

export default DepartmentScreen;
